/**
 * Resolves a public asset path using Vite's BASE_URL.
 *
 * In web mode (staging/production) BASE_URL is "/", so "/logo.png" works.
 * In Electron (file:// protocol) BASE_URL is "./", so absolute paths like
 * "/logo.png" break because they resolve to the filesystem root.
 *
 * Usage: <img src={publicAsset('logo-96.png')} />
 */
export function publicAsset(filename: string): string {
  const name = filename.startsWith('/') ? filename.slice(1) : filename;
  return `${import.meta.env.BASE_URL}${name}`;
}
